"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconBathroomFilled = function IconBathroomFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M43.45 32H5.54002C5.54002 32 4.54001 44 12.36 44H36.36C37.3368 44.0098 38.3037 43.8044 39.1921 43.3982C40.0805 42.9921 40.8684 42.3952 41.5 41.65C43.4138 39.1925 44.4678 36.1746 44.5 33.06C44.5087 32.9194 44.4875 32.7786 44.4379 32.6467C44.3883 32.5149 44.3115 32.395 44.2123 32.2949C44.1132 32.1948 43.9941 32.1168 43.8627 32.066C43.7313 32.0152 43.5907 31.9927 43.45 32Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M43.55 29.1H12.55V11.23C12.5245 10.7878 12.5914 10.3452 12.7463 9.93025C12.9013 9.51532 13.1409 9.13721 13.45 8.81999C14.2477 8.21326 15.2409 7.92137 16.24 7.99999C18.38 7.99999 19.41 8.65999 19.9 9.31999C19.9519 9.39266 19.9865 9.47615 20.0015 9.56416C20.0164 9.65217 20.0111 9.74242 19.9861 9.82811C19.961 9.91379 19.9169 9.99268 19.8569 10.0588C19.797 10.125 19.7228 10.1767 19.64 10.21C18.8541 10.6085 18.2291 11.2653 17.87 12.07C17.68 12.51 18.05 12.97 18.61 12.97H25.22C25.76 12.97 26.15 12.52 25.97 12.09C25.6918 11.4927 25.274 10.971 24.7519 10.569C24.2298 10.1669 23.6186 9.89633 22.97 9.77999C22.8552 9.75817 22.748 9.70715 22.6587 9.63183C22.5693 9.55651 22.5009 9.45944 22.46 9.34999C21.91 7.78999 20.2 5.99999 16.24 5.99999C14.595 5.89869 12.9737 6.43196 11.71 7.48999C11.2001 7.98777 10.8024 8.5888 10.5437 9.2528C10.285 9.9168 10.1712 10.6284 10.21 11.34L10.41 29.1H6.41002C6.15807 29.1 5.91643 29.2001 5.73827 29.3782C5.56011 29.5564 5.46002 29.798 5.46002 30.05C5.46002 30.3019 5.56011 30.5436 5.73827 30.7217C5.91643 30.8999 6.15807 31 6.41002 31H43.51C43.6348 31 43.7583 30.9754 43.8736 30.9277C43.9888 30.8799 44.0936 30.81 44.1818 30.7217C44.27 30.6335 44.34 30.5288 44.3877 30.4135C44.4354 30.2983 44.46 30.1747 44.46 30.05C44.46 29.9252 44.4354 29.8017 44.3877 29.6864C44.34 29.5712 44.27 29.4665 44.1818 29.3782C44.0936 29.29 43.9888 29.22 43.8736 29.1723C43.7583 29.1246 43.6348 29.1 43.51 29.1H43.55Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.11 16.16C19.723 16.16 20.22 15.6765 20.22 15.08C20.22 14.4835 19.723 14 19.11 14C18.497 14 18 14.4835 18 15.08C18 15.6765 18.497 16.16 19.11 16.16Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.34 18.33C21.953 18.33 22.45 17.8465 22.45 17.25C22.45 16.6535 21.953 16.17 21.34 16.17C20.7269 16.17 20.23 16.6535 20.23 17.25C20.23 17.8465 20.7269 18.33 21.34 18.33Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.57 16.16C24.183 16.16 24.68 15.6765 24.68 15.08C24.68 14.4835 24.183 14 23.57 14C22.9569 14 22.46 14.4835 22.46 15.08C22.46 15.6765 22.9569 16.16 23.57 16.16Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.57 20.5C24.183 20.5 24.68 20.0165 24.68 19.42C24.68 18.8235 24.183 18.34 23.57 18.34C22.9569 18.34 22.46 18.8235 22.46 19.42C22.46 20.0165 22.9569 20.5 23.57 20.5Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.8 18.33C26.413 18.33 26.91 17.8465 26.91 17.25C26.91 16.6535 26.413 16.17 25.8 16.17C25.187 16.17 24.69 16.6535 24.69 17.25C24.69 17.8465 25.187 18.33 25.8 18.33Z",
    fill: color
  }));
};

IconBathroomFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconBathroomFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string,
  size: _propTypes.number
};
var _default = IconBathroomFilled;
exports.default = _default;